export default __webpack_public_path__ + "static/perche-scegliere-sviluppo-software-personalizzato-1be393473eeabb47f1bd554eb3060be3.jpg";